import API from "@/api";

export default {
  namespaced: true,

  state: {},

  actions: {
    async getAvailablesOnDistrictByName({}, payload) {
      try {
        return API.Professionals.getAvailablesOnDistrictByName(payload);
      } catch (e) {
        throw e;
      }
    },

    async getAvailableEvents({}, schedule_id) {
      try {
        return API.Professionals.getAvailableEvents(schedule_id);
      } catch (e) {
        throw e;
      }
    },

    async getFeedbacks({}, payload) {
      try {
        return API.Feedbacks.getByProfessional(payload);
      } catch (e) {
        throw e;
      }
    }
  },

  mutations: {},

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/professionals.js